import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("i", _mergeProps({
        style: _ctx.getStyles,
        class: _ctx.getClasses
    }, _ctx.$attrs, {
        onClick: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.listener && _ctx.listener(...args)))
    }), null, 16));
}
